<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>{{!!existingListing && 'edit' || 'add' }}</mat-icon>
      {{ !!existingListing && 'Edit' || 'Add' }} Page
    </h1>
  </section>
  <section mat-dialog-content>
    @if (!!CarouselImageDataSource) {
      <carousel-images-view
        [DataSource]="CarouselImageDataSource"
        [editable]="true"
      ></carousel-images-view>
    }
    <mat-form-field>
      <mat-label>Page Title</mat-label>
      <input formControlName="title" matInput />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Search Terms</mat-label>
      <input formControlName="search_terms" matInput />
      <mat-hint>separate single words/terms with a comma</mat-hint>
    </mat-form-field>
    <quill-editor
      class="form-control"
      formControlName="description"
    ></quill-editor>

    <mat-form-field>
      <mat-select formControlName="colour_scheme" placeholder="Colour Scheme">
        <mat-option value="default"> Default </mat-option>
        <mat-option value="body"> Body </mat-option>
        <mat-option value="mind"> Mind </mat-option>
        <mat-option value="life"> Life </mat-option>
        <mat-option value="soul"> Soul </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox formControlName="promoted_event">Promoted Event</mat-checkbox>
    <mat-checkbox formControlName="retired">Retired only Event</mat-checkbox>
    <start-end-date-picker
      [FormGroup]="form"
      [endDate]="endDate"
      [startDate]="startDate"
    ></start-end-date-picker>

    <mat-form-field>
      <mat-label>Video URL</mat-label>
      <input formControlName="video" type="url" matInput />
      <mat-hint
        >This video will appear in the carousel with the images</mat-hint
        >
      </mat-form-field>

      <mat-form-field>
        <mat-label>Sub offer title</mat-label>
        <input formControlName="offer_label" matInput />
        <mat-hint>for example 'Save' or 'Special event'</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Main Offer title</mat-label>
        <input formControlName="offer" matInput />
        <mat-hint>for example '50% OFF' or 'Eurostar'</mat-hint>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Additional Offer Info</mat-label>
        <input formControlName="offer_terms" matInput />
        <mat-hint
          >for example 'valid 7 days a week' or 'only &pound;140 per person for 7
          days'</mat-hint
          >
        </mat-form-field>
        <mat-form-field>
          <mat-label>External Url</mat-label>
          <input formControlName="external_url" matInput type="url" />
          <mat-hint
            >use if offer or event has an external link to apply online</mat-hint
            >
          </mat-form-field>
          <mat-form-field>
            <mat-label>Button Text</mat-label>
            <input formControlName="button_text" matInput />
            <mat-hint>use if offer or event has custom button text</mat-hint>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Purchase Terms and conditions URL</mat-label>
            <input formControlName="terms_and_conditions" matInput type="url" />
            @if (!!form.get('terms_and_conditions').errors) {
              <mat-error
                >Must be a valid URL</mat-error
                >
              }
              <mat-hint>
                use if offers require custom T&C's other than the standard
                <a [attr.href]="ticketTsAndCs" target="_blank">ticket</a>/<a
                [attr.href]="productTsAndCs"
                target="_blank"
                >product</a
                >
              </mat-hint>
            </mat-form-field>

            <mat-card formGroupName="iframe">
              <mat-card-header>
                <mat-card-subtitle
                  >iframe overlay - This will create an iframe overlay within the
                  listing</mat-card-subtitle
                  >
                </mat-card-header>
                @if (!!iframe?.title) {
                  <mat-card-content
                    ><button mat-button type="button">
                    {{iframe?.title}}
                  </button></mat-card-content
                  >
                }

                @if (editiframe) {
                  <mat-form-field>
                    <mat-label>Iframe URL</mat-label>
                    <input formControlName="url" type="url" matInput />
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Iframe Title</mat-label>
                    <input formControlName="title" type="text" matInput />
                  </mat-form-field>
                }

                <mat-card-actions>
                  @if (editiframe) {
                    <button
                      mat-button
                      type="button"
                      (click)="setIframe()"
                      >
                      <mat-icon>check</mat-icon>save
                    </button>
                  }
                  @if (!editiframe) {
                    <button
                      mat-button
                      type="button"
                      (click)="toggleIframe()"
                      >
                      <mat-icon>edit</mat-icon>edit
                    </button>
                  }
                  @if (!editiframe) {
                    <button
                      mat-button
                      type="button"
                      (click)="clearIframe()"
                      >
                      <mat-icon>close</mat-icon>remove
                    </button>
                  }
                </mat-card-actions>
              </mat-card>
            </section>
            <section align="end" mat-dialog-actions>
              <button
                mat-button
                mat-dialog-close
                matTooltip="Cancel and close."
                type="button"
                >
                <mat-icon>cancel</mat-icon>
                Cancel
              </button>
              <button
                [disabled]="!form.valid"
                mat-button
                matTooltip="Save page."
                type="submit"
                >
                <mat-icon>save</mat-icon>
                Save
              </button>
            </section>
          </form>
